import { createContext, useContext } from "react";
import { ConfirmationComponentProps } from "./Confirmation";

export type ConfirmationProps = {
  confirmationId?: string,
} & Omit<ConfirmationComponentProps, "isOpen" | "onRequestClose">

export type ConfirmationContextProps = {
  confirmations: ConfirmationProps[],
  push: (props: ConfirmationProps) => ConfirmationProps,
  remove: (confirmationId: string | undefined) => void,
}

export const ConfirmationContext = createContext<ConfirmationContextProps>({
  confirmations: [],
  remove: confirmationId => {
    throw new Error("Not implemented");
  },
  push: props => {
    throw new Error("Not implemented");
  },
});

export const useConfirmation = () => useContext(ConfirmationContext);

export default ConfirmationContext;

